import { styled } from 'linaria/react';
import React from 'react';
import { FaMapMarkerAlt } from 'react-icons/fa';
import { ITrainingPlace } from '../../hooks/useTrainingPlaces';
import GoogleMapReact from 'google-map-react';
import { TrainingPlaceHeader } from '../TrainingPlaceHeader/TrainingPlaceHeader';
import { theme } from '../../../Theme/Theme';

const MarkerIconWrapper = styled.div`
  .marker {
    font-size: 3rem;
    fill: ${theme.color.primary};
    color: ${theme.color.primary};
    transform: translate(-50%, -100%);
  }
`;
const MarkerIcon = (props: any) => (
  <MarkerIconWrapper>
    <FaMapMarkerAlt className="marker" />
  </MarkerIconWrapper>
);

export interface TrainingPlaceProps extends ITrainingPlace {
  className?: string;
}

const isClient = typeof window !== 'undefined';

const TrainingPlaceInner = (props: TrainingPlaceProps) => {
  const { name, address, coordinates, mapLink } = props;
  return (
    <article className={props.className}>
      <div className="header">
        <TrainingPlaceHeader name={name} address={address} />
      </div>
      <div className="map">
        <a href={mapLink} target="_blank" rel="noopener noreferrer">
          {isClient && (
            <GoogleMapReact
              bootstrapURLKeys={{
                key: 'AIzaSyBpg7gOHO_jF3wGQkV3GV26cuO5KlsFCbM'
              }}
              defaultCenter={coordinates}
              defaultZoom={15}
            >
              <MarkerIcon
                className="marker"
                lat={coordinates.lat}
                lng={coordinates.lng}
              />
            </GoogleMapReact>
          )}
        </a>
      </div>
    </article>
  );
};

export const TrainingPlace = styled(TrainingPlaceInner)`
  max-width: 280px;
  margin: auto;
  .map {
    margin-top: 30px;
    height: 175px;
  }
`;
